/**
 * Generate Study Dialog - Step 2: Select Product
 *
 * Migrated from: lego/page/etmf/overview/generate-study/Step2.jsx
 */

import React from 'react'
import { FormikProps } from 'formik'
import { useDialogContext } from './context/useDialogContext'
import { useServiceContext } from '../../../../root'
import { Select } from '../../../../components/Select/Select'
import type { FormValues } from './context/DialogContext'
import type { OptionType } from '../../../../components/Select/Select'

interface Step2Props extends Partial<FormikProps<FormValues>> {}

export function Step2({ values, setFieldValue, errors }: Step2Props) {
  const dialogData = useDialogContext()
  const context = useServiceContext()
  const { translate } = context.service.filter

  // Transform SelectOption to OptionType format for the Select component
  const options: OptionType[] = (dialogData.productOptions || []).map((opt) => ({
    value: opt.value,
    label: opt.label
  }))

  return (
    <div className="step step2">
      <div className="form-group w50p">
        <div className="mcc-form-group">
          <label htmlFor="product-select" className="has-step-circle control-label mb10">
            <span className="step-circle">1</span>
            <span>{translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP3')}</span>
          </label>
        </div>
        <Select
          id="product-select"
          name="product"
          value={values?.product}
          options={options}
          placeholder={translate('SELECT_PRODUCT')}
          isClearable={false}
          isSearchable={true}
          onChange={(option) => {
            setFieldValue?.('product', option ? (option as OptionType).value : null)
          }}
        />
        {errors?.product && <div className="text-danger fs14">{errors.product}</div>}
      </div>
    </div>
  )
}

export default Step2
